export const NIAT_APPLICATION_MACHINE_ID = 'niatApplicationMachine';

export const niatApplicationMachineStates = {
  getUserApplicationDetailState: 'getUserApplicationDetailState',
  fetchUserProfileDetailsState: 'fetchUserProfileDetailsState',
  userApplicationNotExitState: 'userApplicationNotExitState',
  userApplicationDetailEditState: 'userApplicationDetailEditState',
  initializeAuthCoreMachineForStudent: 'initializeAuthCoreMachineForStudent',
  goToCreateApplicationState: 'goToCreateApplicationState',
  goToApplicationSectionPageState: 'goToApplicationSectionPageState',
  userApplicationDetailSectionsState: 'userApplicationDetailSectionsState',
  updateUserProfileDetailGraphQlState: 'updateUserProfileDetailGraphQlState',
  fetchUserProfileDetailsGraphQlState: 'fetchUserProfileDetailsGraphQlState',
  updateUserIntermediateDetailGraphQlState:
    'updateUserIntermediateDetailGraphQlState',
  updateUserDegreeDetailsGraphQlState: 'updateUserDegreeDetailsGraphQlState',
  linkUserApplicationState: 'linkUserApplicationState',
  linkStudentToParentState: 'linkStudentToParentState',
  getStudentAuthCodeState: 'getStudentAuthCodeState',
  getInitialValueOfAllFieldsState: 'getInitialValueOfAllFieldsState',
  updateFieldValuesState: 'updateFieldValuesState',
  logoutParentState: 'logoutParentState',
  updateStudentDetailsState: 'updateStudentDetailsState',
  getFormConfigState: 'getFormConfigState',
  getIbFormSubmissionDetailsState: 'getIbFormSubmissionDetailsState',
  getProductConfigState: 'getProductConfigState',
  getStudentProfileDetailState: 'getStudentProfileDetailState',
  getParentProfileDetailState: 'getParentProfileDetailState',
  submitApplicationFormState: 'submitApplicationFormState',
  getStudentAuthDetailsState: 'getStudentAuthDetailsState',
  getReferralCodeDetailState: 'getReferralCodeDetailState',
  getCouponCodeDetailState: 'getCouponCodeDetailState',
  getSelectedProductPaymentServiceState:
    'getSelectedProductPaymentServiceState',
  getOrderStatusState: 'getOrderStatusState',
  createPaymentOrderAndGetDetailState: 'createPaymentOrderAndGetDetailState',
  cancelPaymentOrderState: 'cancelPaymentOrderState',
  updateTemplateResponseState: 'updateTemplateResponseState',
  updateEnrollmentPaidStatusState: 'updateEnrollmentPaidStatusState',
  updateMultipleTemplateResponseState: 'updateMultipleTemplateResponseState',
  getTemplateResponseState: 'getTemplateResponseState',
  updateSectionFieldsValueState: 'updateSectionFieldsValueState',
  getCampusVisitProductConfigState: 'getCampusVisitProductConfigState',
  submitCampusVisitSchedulerProductState:
    'submitCampusVisitSchedulerProductState',
  updateWhoIsFillingState: 'updateWhoIsFillingState',
  updateDefaultWhoAmIFieldState: 'updateDefaultWhoAmIFieldState',
  updateStudentCurrentEducationState: 'updateStudentCurrentEducationState',
  updateStudentAcademicStreamState: 'updateStudentAcademicStreamState',
  updateApplicationDetailsState: 'updateApplicationDetailsState',
  getStudentApplicationDetailsState: 'getStudentApplicationDetailsState',
  sendEventOnPhoneNumberVerifiedState: 'sendEventOnPhoneNumberVerifiedState',
  sendEventOnApplicationFormSubmitState:
    'sendEventOnApplicationFormSubmitState',
  getApplicationDiscountDetailsState: 'getApplicationDiscountDetailsState',
  recordDiscountInteractionState: 'recordDiscountInteractionState',
  getFormReferralCodeState: 'getFormReferralCodeState',
  trackFormReferralAttemptState: 'trackFormReferralAttemptState',
  updateFirstVisitDatetimeState: 'updateFirstVisitDatetimeState',
  getTopinExamAuthCodeState: 'getTopinExamAuthCodeState',
  getAvailableProgramInstitutesState: 'getAvailableProgramInstitutesState',
  createUserProgramInstituteState: 'createUserProgramInstituteState',
  getUserProgramInstituteCoursesState: 'getUserProgramInstituteCoursesState',
  getUserOrdersDetailsState: 'getUserOrdersDetailsState',
  getSelectedInstituteCoursesState: 'getSelectedInstituteCoursesState',
  decideEnrollmentFlowState: 'decideEnrollmentFlowState',
  getBootcampRegistrationFormSubmissionState:
    'getBootcampRegistrationFormSubmissionState'
};

export const niatApplicationMachineEvents = {
  updateLoggedInUserRole: 'UPDATE_LOGGED_IN_USER_ROLE',
  doSelfTransition: 'DO_SELF_TRANSITION',
  getOtpForStudentPhoneNumber: 'GET_OTP_FOR_STUDENT_PHONE_NUMBER',
  onClickProceedButton: 'ON_CLICK_PROCEED_BUTTON',
  updateUserProfileDetailGraphQl: 'UPDATE_USER_PROFILE_DETAIL_GRAPH_QL',
  updateUserIntermediateDetailGraphQl:
    'UPDATE_USER_INTERMEDIATE_DETAIL_GRAPH_QL',
  updateUserDegreeDetailsGraphQl: 'UPDATE_USER_DEGREE_DETAILS_GRAPH_QL',
  onEntryGetOTP: 'ON_ENTRY_GET_OTP',
  onEntryGetEmailOtp: 'ON_ENTRY_GET_EMAIL_OTP',
  onSuccessGetOTP: 'ON_SUCCESS_GET_OTP',
  onSuccessGetEmailOTP: 'ON_SUCCESS_GET_EMAIL_OTP',
  onErrorGetOTP: 'ON_ERROR_GET_OTP',
  onErrorGetEmailOTP: 'ON_ERROR_GET_EMAIL_OTP',
  onSuccessGetSignUpOTP: 'ON_SUCCESS_GET_SIGN_UP_OTP',
  onSuccessOtpVerification: 'ON_SUCCESS_OTP_VERIFICATION',
  updateCurrentSelectedSectionTabId: 'UPDATE_CURRENT_SELECTED_SECTION_TAB_ID',
  navigateFromQualifiedPreview: 'NAVIGATE_FROM_QUALIFIED_PREVIEW',
  goToSendEmailOtpState: 'GO_TO_SEND_EMAIL_OTP_STATE',
  onSuccessEmailOtpVerification: 'ON_SUCCESS_EMAIL_OTP_VERIFICATION',
  goToGetInitialValueOfAllFieldsState: 'GO_TO_GET_INITIAL_VALUE_OF_ALL_FIELDS',
  updateFieldValues: 'UPDATE_FIELD_VALUES',
  updateEnrollmentPaidStatus: 'UPDATE_ENROLLMENT_PAID_STATUS',
  initializeAuthMachineAndGetOtp: 'INITIALIZE_AUTH_MACHINE_AND_GET_OTP',
  submitApplicationForm: 'SUBMIT_APPLICATION_FORM',
  getReferralCodeDetail: 'GET_REFERRAL_CODE_DETAIL',
  getCouponCodeDetails: 'GET_COUPON_CODE_DETAILS',
  resetErrorMessageAndApiStatus: 'RESET_ERROR_MESSAGE_AND_API_STATUS',
  onClickContinueToPay: 'ON_CLICK_CONTINUE_TO_PAY',
  cancelPaymentOrder: 'CANCEL_PAYMENT_ORDER',
  getPaymentStatus: 'GET_PAYMENT_STATUS',
  updateTemplateResponse: 'UPDATE_TEMPLATE_RESPONSE',
  updateSectionPercentage: 'UPDATE_SECTION_PERCENTAGE',
  updateApplicationProductDiscount: 'UPDATE_APPLICATION_PRODUCT_DISCOUNT',
  updateMultiStepApi: 'UPDATE_MULTI_STEP_API',
  sectionProceedButtonClick: 'SECTION_PROCEED_BUTTON_CLICK',
  submitCampusVisitSchedulerProduct: 'SUBMIT_CAMPUS_VISIT_SCHEDULER_PRODUCT',
  initializeProductsMachine: 'INITIALIZE_PRODUCTS_MACHINE',
  getFormConfig: 'GET_FORM_CONFIG',
  setShouldShowSuccessPage: 'SET_SHOULD_SHOW_SUCCESS_PAGE',
  resetAuthMachine: 'RESET_AUTH_MACHINE',
  updateApplicationDetails: 'UPDATE_APPLICATION_DETAILS',
  updateShouldDisableAllSectionsTabs: 'UPDATE_SHOULD_DISABLE_ALL_SECTIONS_TABS',
  updateCurrentSectionType: 'UPDATE_CURRENT_SECTION_TYPE',
  recordDiscountInteraction: 'RECORD_DISCOUNT_INTERACTION',
  setDiscountPopupVisibility: 'SET_DISCOUNT_POPUP_VISIBILITY',
  setHasRecordedCopyInteraction: 'SET_HAS_RECORDED_COPY_INTERACTION',
  setShowCongratulationsModal: 'SET_SHOW_CONGRATULATIONS_MODAL',
  logCloudWatchEvent: 'LOG_CLOUD_WATCH',
  resetCouponCode: 'RESET_COUPON_CODE',
  updateContextValues: 'UPDATE_CONTEXT_VALUES',
  setEnrollmentCourseIdForPayment: 'SET_ENROLLMENT_COURSE_ID_FOR_PAYMENT',
  updateSeatReservationFlow: 'UPDATE_SEAT_RESERVATION_FLOW',
  updateFirstVisitDatetime: 'UPDATE_FIRST_VISIT_DATETIME',
  getTopinExamAuthCode: 'GET_TOPIN_EXAM_AUTH_CODE',
  getAvailableProgramInstitutes: 'GET_AVAILABLE_PROGRAM_INSTITUTES',
  createUserProgramInstitute: 'CREATE_USER_PROGRAM_INSTITUTE',
  getUserProgramInstituteCourses: 'GET_USER_PROGRAM_INSTITUTE_COURSES',
  SET_USER_ENROLLMENT_STAGE: 'SET_USER_ENROLLMENT_STAGE',
  updateSeatReservationInstituteSectionDetails:
    'UPDATE_SEAT_RESERVATION_INSTITUTE_SECTION_DETAILS',
  getBootcampRegistrationFormSubmission:
    'GET_BOOTCAMP_REGISTRATION_FORM_SUBMISSION'
} as const;

export const niatApplicationMachineServices = {
  logOutParent: 'logOutParent',
  getUserApplicationDetails: 'getUserApplicationDetails',
  getUserProfileDetails: 'getProfileDetails',
  createUserApplication: 'createUserApplication',
  updateUserApplication: 'updateUserApplication',
  getUserProfileDetailGraphQL: 'getUserProfileDetailGraphQL',
  updateUserProfileDetailsGraphQL: 'updateUserProfileDetailsGraphQL',
  updateUserIntermediateDetailGraphQL: 'updateUserIntermediateDetailGraphQL',
  updateUserDegreeDetailsGraphQL: 'updateUserDegreeDetailsGraphQL',
  linkUserApplication: 'linkUserApplication',
  updateUserGuardianDetailsGraphQL: 'updateUserGuardianDetailsGraphQL',
  getUserApplicationSectionsDetails: 'getUserApplicationSectionsDetails',
  getStudentAuthCode: 'getStudentAuthCode',
  getInitialValueOfAllFields: 'getInitialValueOfAllFields',
  updateFieldValues: 'updateFieldValues',
  linkStudentToParent: 'linkStudentToParent',
  getStudentProfileDetailWithAccessToken:
    'getStudentProfileDetailWithAccessToken',
  getParentProfileDetailWithAccessToken:
    'getParentProfileDetailWithAccessToken',
  updateStudentDetails: 'updateStudentDetails',
  getFormConfig: 'getFormConfig',
  getIbFormSubmissionDetails: 'getIbFormSubmissionDetails',
  getProductConfig: 'getProductConfig',
  submitApplicationForm: 'submitApplicationForm',
  getStudentAuthDetails: 'getStudentAuthDetails',
  getReferralCodeDetail: 'getReferralCodeDetail',
  getSelectedProductPaymentService: 'getSelectedProductPaymentService',
  createPaymentOrderAndGetDetail: 'createPaymentOrderAndGetDetail',
  getOrderStatus: 'getOrderStatus',
  cancelPaymentOrder: 'cancelPaymentOrder',
  updateTemplateResponse: 'updateTemplateResponse',
  updateEnrollmentPaidStatus: 'updateEnrollmentPaidStatus',
  updateMultipleTemplateResponse: 'updateMultipleTemplateResponse',
  getTemplateResponse: 'getTemplateResponse',
  updateDefaultWhoAmIField: 'updateDefaultWhoAmIField',
  updateSectionFieldsValue: 'updateSectionFieldsValue',
  getCampusVisitProductConfig: 'getCampusVisitProductConfig',
  submitCampusVisitSchedulerProduct: 'submitCampusVisitSchedulerProduct',
  updateWhoIsFilling: 'updateWhoIsFilling',
  updateStudentCurrentEducation: 'updateStudentCurrentEducation',
  updateStudentAcademicStream: 'updateStudentAcademicStream',
  verifyPhoneNumberOtp: 'verifyPhoneNumberOtp',
  sendEventOnApplicationSubmit: 'sendEventOnApplicationSubmit',
  sendEventOnPhoneNumberVerified: 'sendEventOnPhoneNumberVerified',
  getApplicationDiscountDetails: 'getApplicationDiscountDetails',
  recordDiscountInteraction: 'recordDiscountInteraction',
  getFormReferralCode: 'getFormReferralCode',
  trackFormReferralAttempt: 'trackFormReferralAttempt',
  updateFirstVisitDatetime: 'updateFirstVisitDatetime',
  getTopinExamAuthCode: 'getTopinExamAuthCode',
  getAvailableProgramInstitutes: 'getAvailableProgramInstitutes',
  createUserProgramInstitute: 'createUserProgramInstitute',
  getUserProgramInstituteCourses: 'getUserProgramInstituteCourses',
  getUserOrdersDetails: 'getUserOrdersDetails',
  getSelectedInstituteCourses: 'getSelectedInstituteCourses',
  getBootcampRegistrationFormSubmission: 'getBootcampRegistrationFormSubmission'
};

export const niatApplicationMachineTags = {};

export const niatApplicationMachineGuards = {
  isUserApplicationNotExists: 'isUserApplicationNotExists',
  isUserApplicationNotExistsAndLoggedInUserRoleParent:
    'isUserApplicationNotExistsAndLoggedInUserRoleParent',
  isLoggedInUserRoleParent: 'isLoggedInUserRoleParent',
  isStudentApplicationExist: 'isStudentApplicationExist',
  isParentApplicationExits: 'isParentApplicationExits',
  isParentApplicationExitAndParentLoggedIn:
    'isParentApplicationExitAndParentLoggedIn',
  checkIfStudentApplicationExistInResponse:
    'checkIfStudentApplicationExistInResponse',
  isCurrentAuthenticationFieldParentOrGuardianMobileNumber:
    'isCurrentAuthenticationFieldParentOrGuardianMobileNumber',
  checkIfParentLoggedIn: 'checkIfParentLoggedIn',
  checkIfParentLoggedInAndStudentApplicationExit:
    'checkIfParentLoggedInAndStudentApplicationExit',
  checkIfParentLoggedInAndStudentApplicationNotExit:
    'checkIfParentLoggedInAndStudentApplicationNotExit',
  isCurrentAuthenticationFieldParentOrGuardianMobileNumberAndOtpVerified:
    'isCurrentAuthenticationFieldParentOrGuardianMobileNumberAndOtpVerified',
  isProductAmountToBePaidZero: 'isProductAmountToBePaidZero',
  isGraphQLApiHasFailureResponse: 'isGraphQLApiHasFailureResponse',
  shouldTrackFormReferralAttempt: 'shouldTrackFormReferralAttempt',
  doesUserProgramInstituteCourseRowHaveInstituteId:
    'doesUserProgramInstituteCourseRowHaveInstituteId',
  doesSelectedInstituteHaveCourses: 'doesSelectedInstituteHaveCourses',
  shouldGetAvailableProgramInstitutesAfterUserOrders:
    'shouldGetAvailableProgramInstitutesAfterUserOrders'
};

export const niatApplicationMachineActions = {
  onSuccessGettingUserApplicationDetails:
    'onSuccessGettingUserApplicationDetails',
  assignErrorMessageToContext: 'assignErrorMessageToContext',
  clearErrorMessageFromContext: 'clearErrorMessageFromContext',
  onSuccessProfileDetails: 'onSuccessProfileDetails',
  onSuccessGetGraphQLProfileDetails: 'onSuccessGetGraphQLProfileDetails',
  spawnAuthCoreMachine: 'spawnAuthCoreMachine',
  onSuccessCreateUserApplication: 'onSuccessCreateUserApplication',
  onSuccessUpdateUserApplication: 'onSuccessUpdateUserApplication',
  goToApplicationSectionPage: 'goToApplicationSectionPage',
  updateUserGraphQlProfileDetailsInContext:
    'updateUserGraphQlProfileDetailsInContext',
  setIsGetOtpButtonLoadingToTrue: 'setIsGetOtpButtonLoadingToTrue',
  setIsGetOtpButtonLoadingToFalse: 'setIsGetOtpButtonLoadingToFalse',
  setIsProceedButtonLoadingToTrue: 'setIsProceedButtonLoadingToTrue',
  setIsGetEmailOtpButtonLoadingToTrue: 'setIsGetEmailOtpButtonLoadingToTrue',
  assignInviteCodeToContext: 'assignInviteCodeToContext',
  setIsGetEmailOtpButtonLoadingToFalse: 'setIsGetEmailOtpButtonLoadingToFalse',
  onSuccessGetEmailOtp: 'onSuccessGetEmailOtp',
  onSuccessEmailOtpVerification: 'onSuccessEmailOtpVerification',
  onEntryGetEmailOtp: 'onEntryGetEmailOtp',
  onEntryGetPhoneNumberOtp: 'onEntryGetPhoneNumberOtp',
  onSuccessPhoneNumberOtpVerification: 'onSuccessPhoneNumberOtpVerification',
  setIsProceedButtonLoadingToFalse: 'setIsProceedButtonLoadingToFalse',
  updateLoggedInUserRole: 'updateLoggedInUserRole',
  onSuccessLinkStudentToParent: 'onSuccessLinkStudentToParent',
  onSuccessGettingUserApplicationSectionsDetails:
    'onSuccessGettingUserApplicationSectionsDetails',
  setStudentLoginDetails: 'setStudentLoginDetails',
  setParentLoginDetails: 'setParentLoginDetails',
  updateValueOnContext: 'updateValueOnContext',
  setEnrollmentCourseIdForPayment: 'setEnrollmentCourseIdForPayment',
  updateCurrentSelectedSectionTabId: 'updateCurrentSelectedSectionTabId',
  navigateFromQualifiedPreview: 'navigateFromQualifiedPreview',
  onSuccessGetInitialValueOfAllFields: 'onSuccessGetInitialValueOfAllFields',
  onEntryUpdateFieldValues: 'onEntryUpdateFieldValues',
  onSuccessUpdateFieldValues: 'onSuccessUpdateFieldValues',
  onFailUpdateFieldValues: 'onFailUpdateFieldValues',
  spawnFieldSpecificAuthMachine: 'spawnFieldSpecificAuthMachine',
  onSuccessGetStudentProfileDetail: 'onSuccessGetStudentProfileDetail',
  onSuccessGetParentProfileDetail: 'onSuccessGetParentProfileDetail',
  onSuccessLogOutParent: 'onSuccessLogOutParent',
  onSuccessUpdateStudentDetails: 'onSuccessUpdateStudentDetails',
  onSuccessGetFormConfig: 'onSuccessGetFormConfig',
  onSuccessGetIbFormSubmissionDetails: 'onSuccessGetIbFormSubmissionDetails',
  onSuccessGetBootcampRegistrationFormSubmission:
    'onSuccessGetBootcampRegistrationFormSubmission',
  onErrorGetIbFormSubmissionDetails: 'onErrorGetIbFormSubmissionDetails',
  onSuccessGetProductConfig: 'onSuccessGetProductConfig',
  setCurrentAuthenticationField: 'setCurrentAuthenticationField',
  onSuccessSubmitApplicationForm: 'onSuccessSubmitApplicationForm',
  onFailGetGraphQLProfileDetails: 'onFailGetGraphQLProfileDetails',
  onFailGetInitialValueOfAllFields: 'onFailGetInitialValueOfAllFields',
  onSuccessGetStudentAuthDetails: 'onSuccessGetStudentAuthDetails',
  onFailGetStudentAuthDetails: 'onFailGetStudentAuthDetails',
  onSuccessGetReferralCodeDetail: 'onSuccessGetReferralCodeDetail',
  onErrorGetReferralCodeDetail: 'onErrorGetReferralCodeDetail',
  onSuccessGetCouponCodeDetail: 'onSuccessGetCouponCodeDetail',
  onErrorGetCouponCodeDetail: 'onErrorGetCouponCodeDetail',
  resetErrorMessageAndApiStatus: 'resetErrorMessageAndApiStatus',
  onSuccessGetSelectedProductPaymentServices:
    'onSuccessGetSelectedProductPaymentServices',
  onSuccessCreatePaymentOrderAndGetDetail:
    'onSuccessCreatePaymentOrderAndGetDetail',
  onErrorCreatePaymentOrderAndGetDetail:
    'onErrorCreatePaymentOrderAndGetDetail',
  onSuccessCancelPaymentOrder: 'onSuccessCancelPaymentOrder',
  onSuccessGettingPaymentStatus: 'onSuccessGettingPaymentStatus',
  onFailGettingPaymentStatus: 'onFailGettingPaymentStatus',
  handleErrorOnFailureGetClientConfigDetails:
    'handleErrorOnFailureGetClientConfigDetails',
  setLoginAccessAndRefreshToken: 'setLoginAccessAndRefreshToken',
  onSuccessUpdatingTemplateResponse: 'onSuccessUpdatingTemplateResponse',
  onSuccessGettingTemplateResponse: 'onSuccessGettingTemplateResponse',
  onErrorUpdatingTemplateResponse: 'onErrorUpdatingTemplateResponse',
  onSuccessUpdatingMultipleTemplateResponse:
    'onSuccessUpdatingMultipleTemplateResponse',
  onErrorUpdatingMultipleTemplateResponse:
    'onErrorUpdatingMultipleTemplateResponse',
  onErrorGettingTemplateResponse: 'onErrorGettingTemplateResponse',
  updateMultiStepApi: 'updateMultiStepApi',
  onErrorUpdateSectionFieldValues: 'onErrorUpdateSectionFieldValues',
  onSuccessGetCampusVisitProductConfig: 'onSuccessGetCampusVisitProductConfig',
  onSuccessSubmitCampusVisitSchedulerProduct:
    'onSuccessSubmitCampusVisitSchedulerProduct',
  onErrorSubmitCampusVisitSchedulerProduct:
    'onErrorSubmitCampusVisitSchedulerProduct',
  initializeProductsMachine: 'initializeProductsMachine',
  onErrorSubmitApplicationForm: 'onErrorSubmitApplicationForm',
  onErrorVerifyPhoneNumberOtp: 'onErrorVerifyPhoneNumberOtp',
  logCloudWatchEvent: 'logCloudWatchEvent',
  onSuccessGetApplicationDiscountDetails:
    'onSuccessGetApplicationDiscountDetails',
  onSuccessRecordDiscountInteraction: 'onSuccessRecordDiscountInteraction',
  setDiscountPopupVisibility: 'setDiscountPopupVisibility',
  setHasRecordedCopyInteraction: 'setHasRecordedCopyInteraction',
  onSuccessGetFormReferralCode: 'onSuccessGetFormReferralCode',
  onErrorTrackFormReferralAttemptLogEntry:
    'onErrorTrackFormReferralAttemptLogEntry',
  setIsFieldUpdateInProgressToTrue: 'setIsFieldUpdateInProgressToTrue',
  setIsFieldUpdateInProgressToFalse: 'setIsFieldUpdateInProgressToFalse',
  assignSeatReservationFlowToContext: 'assignSeatReservationFlowToContext',
  onSuccessUpdateFirstVisitDatetime: 'onSuccessUpdateFirstVisitDatetime',
  onSuccessGetTopinExamAuthCode: 'onSuccessGetTopinExamAuthCode',
  onErrorGetTopinExamAuthCode: 'onErrorGetTopinExamAuthCode',
  setIsGetTopinExamAuthCodeLoadingToFalse:
    'setIsGetTopinExamAuthCodeLoadingToFalse',
  setAvailableProgramInstitutesLoading: 'setAvailableProgramInstitutesLoading',
  onSuccessGetAvailableProgramInstitutes:
    'onSuccessGetAvailableProgramInstitutes',
  onErrorGetAvailableProgramInstitutes: 'onErrorGetAvailableProgramInstitutes',
  onSuccessCreateUserProgramInstitute: 'onSuccessCreateUserProgramInstitute',
  onErrorCreateUserProgramInstitute: 'onErrorCreateUserProgramInstitute',
  setUserProgramInstituteCoursesLoading:
    'setUserProgramInstituteCoursesLoading',
  onSuccessGetUserProgramInstituteCourses:
    'onSuccessGetUserProgramInstituteCourses',
  onErrorGetUserProgramInstituteCourses:
    'onErrorGetUserProgramInstituteCourses',
  setUserOrdersDetailsLoading: 'setUserOrdersDetailsLoading',
  onSuccessGetUserOrdersDetails: 'onSuccessGetUserOrdersDetails',
  onErrorGetUserOrdersDetails: 'onErrorGetUserOrdersDetails',
  onSuccessGetSelectedInstituteCourses: 'onSuccessGetSelectedInstituteCourses',
  onErrorGetSelectedInstituteCourses: 'onErrorGetSelectedInstituteCourses',
  setUserEnrollMentStage: 'setUserEnrollMentStage',
  updateSeatReservationInstituteSectionDetails:
    'updateSeatReservationInstituteSectionDetails'
};
